import PlaceholderBody from "./PlaceholderBody";

export default PlaceholderBody;
